export const getVideoMetaData = (src) => {
    return new Promise((resolve) => {
        const video = document.createElement("video");
        video.src = src;
        video.addEventListener("loadedmetadata", () => {
            resolve(video);
        });
    });
};
